// Matches the legacy `Bg` atom in app/frontend/index.html.
// Small uppercase pill with custom fg/bg colors.

import type { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  color: string;
  bg: string;
}

export function Badge({ children, color, bg }: BadgeProps) {
  return (
    <span
      className="inline-block px-2 py-[2px] rounded-[3px] text-[10px] font-bold tracking-[0.05em] font-mono uppercase"
      style={{ color, background: bg }}
    >
      {children}
    </span>
  );
}
